export default "__VITE_ASSET__DeDVMWAK__"